import { useState } from 'react';
import PowerBiMainProductGroupModel from '../product/PowerBiMainProductGroup';

const MinMaxReportModel = () => {
  const initialState = {
    whseList: [],
    abcClassList: [],
    mainProductGroupList: PowerBiMainProductGroupModel().initialState,
    avgDemand: new Number(),
    fromDate: new Date(), // YYYY-MM-DD
    toDate: new Date(), // YYYY-MM-DD
  };
  const [minMaxReport, setMinMaxReport] = useState(initialState);

  const resetMinMaxReport = () => {
    setMinMaxReport(initialState);
  };
  return { minMaxReport, setMinMaxReport, resetMinMaxReport, initialState };
};

export default MinMaxReportModel;
